import { render, staticRenderFns } from "./SkinsView.vue?vue&type=template&id=becfc160&scoped=true&"
import script from "./SkinsView.vue?vue&type=script&lang=ts&"
export * from "./SkinsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becfc160",
  null
  
)

export default component.exports